'use client';
import { Card, CardContent, Typography, useTheme } from '@mui/material';
import Link from 'next/link';

import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';
import { getImageUrl } from '@/lib/helpers/getImageUrl';
import { ComponentBlocksPostcard, Enum_Componentshareddisplayoptions_Contentswidth } from '@/types';

export function Postcard({ blocks }: { blocks: ComponentBlocksPostcard }) {
  const theme = useTheme();
  return (
    <CustomBackground
      backgroundOptions={(blocks?.PostcardBlockBackground ?? undefined) as StrapiBackgroundOptions}
      displayOptions={
        (blocks?.PostcardDisplayOptions ?? {
          ContentsWidth: Enum_Componentshareddisplayoptions_Contentswidth.Wide,
          PaddingTop: 'md',
          PaddingBottom: 'md',
          PaddingInline: 'sm',
        }) as StrapiDisplayOptions | undefined
      }
      boxProps={{
        sx: {
          'data-component': 'TableWidget',
        },
      }}
    >
      <Card
        sx={{
          backgroundImage: `url(${getImageUrl({ image: blocks?.Background, size: 'url' }) || ''})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: 4,
          pt: 12,
          my: 4,
          boxShadow: 'inset 0 0 0 2000px rgba(0, 0, 0, 0.3)',
          '&:hover': {
            boxShadow: 'inset 0 0 0 2000px rgba(0, 0, 0, 0.4)',
          },
          a: {
            textDecoration: 'none',
            color: theme.palette.common.white,
            '&:hover': {
              color: theme.palette.common.white,
              textDecoration: 'underline',
            },
          },
        }}
      >
        <Link href={blocks?.Url ?? '#'}>
          <CardContent
            sx={{
              alignContent: 'baseline',
              alignItems: 'baseline',
              mr: { md: 28 },
              ml: { md: 4 },
            }}
          >
            {blocks.Tagline && (
              <Typography
                variant="label2"
                component="p"
                sx={{
                  marginBottom: 1,
                  'a &': {
                    textDecoration: 'none',
                  },
                }}
              >
                {blocks.Tagline}
              </Typography>
            )}
            <Typography gutterBottom variant="h5" component="h3" fontWeight="bold">
              {blocks.Title}
            </Typography>
          </CardContent>
        </Link>
      </Card>
    </CustomBackground>
  );
}
